<template>
    <div class="bee_pc_invite_base_layout">

        <div class="pc_header">
            <div class="logo_header">
                <div class="logo_ic" @click.stop="pcBack()">
                </div>
            </div>
        </div>

        <div class="pc_content_layout">

            <div class="pc_back_layout">
                <div class="ic_back" @click="pcBack">
                </div>
                <div class="back_home_txt">
                    Home
                </div>
                <div class="ic_back_right"></div>

                <div class="back_invite_txt">
                    Friends
                </div>
            </div>

            <div class="content_pc_layout">


                <div class="invite_info_layout">

                    <div class="pc_invite_info_layout">

                        <div class="pc_invite_title_txt">Bring pal, earn more!</div>

                        <div class="info_line"></div>

                        <div class="mobile_invite_info">For each new friend, you'll receive <span class="red_xp_num">{{
                            normalOnceRewardAmount
                                }}xp</span> plus <span class="red_xp_num">{{ dividendYield }}%</span> of all their
                            XP
                            earnings
                        </div>


                    </div>

                    <div>
                        <div class="img_ipx" />
                    </div>

                </div>
                <div class="pc_invite_content_layout">

                    <div class="index_base_layout">
                        <div class="index_layout"></div>
                        <div class="index_title">Invite rewards</div>
                    </div>

                    <div class="my_invite_xp_layout">

                        <div>
                            <div class="xp_txt">
                                <span class="xp_num_txt">{{ xpCanClaimAmount }}</span>
                                XP
                            </div>
                            <div class="my_txt">Invite rewards</div>
                        </div>

                        <div v-if="isClaim" class="submit_load">
                            <div class="loading_logo"></div>
                        </div>

                        <div v-else :class="xpCanClaimAmount != 0 ? 'submit_get' : 'submit_get_un'" @click="clickClaim">
                            Claim
                        </div>
                    </div>

                    <div class="index_base_layout">
                        <div class="index_layout"></div>
                        <div class="index_title">Invite</div>
                    </div>

                    <div class="invite_layout">

                        <div class="invite_item_layout">
                            <div class="invite_left_txt">Invite Code</div>
                            <div class="invite_right_layout">
                                <div class="invite_right_txt_pc">{{ inviteCode }}</div>
                                <div class="icon_copy" @click="xcopyToClipboard(inviteCode)"></div>
                            </div>
                        </div>

                        <div class="line"></div>

                        <div class="invite_item_layout">
                            <div class="invite_left_txt">Invite link</div>
                            <div class="invite_right_layout">
                                <div class="invite_right_txt_pc">{{ inviteUrl }}</div>
                                <div class="icon_copy" @click="xcopyToClipboard(inviteUrl)"></div>
                            </div>
                        </div>

                    </div>



                    <div class="index_base_layout">
                        <div class="index_layout"></div>
                        <div class="index_title">Share</div>
                    </div>


                    <div class="share_layout">
                        <a :href="twitter_url">
                            <div class="x_share" target="_blank"></div>
                        </a>
                        <a :href="tg_url">
                            <div class="tg_share" target="_blank"></div>
                        </a>
                        <a :href="facebook_url">
                            <div class="fb_share" target="_blank"></div>
                        </a>
                        <a :href="in_url">
                            <div class="in_share" target="_blank"></div>
                        </a>
                        <a :href="email_url" target="_blank">
                            <div class="email_share"></div>
                        </a>

                        <div class="more_share" @click="share"></div>

                    </div>



                    <div class="index_base_layout">
                        <div class="index_layout"></div>
                        <div class="index_title">Friends list</div>
                    </div>
                    <UserListView :listData="listData"></UserListView>

                    <div style="margin-bottom: 40px;visibility: hidden;">bee.com</div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import UserListView from "../view/UserListView.vue"
import Toast from "../message.js";

export default {
    name: 'pcLayout',

    components: {
        UserListView
    },
    emits: ["claim"],
    props: {
        inviteUrl: "",
        inviteDispayUrl: "",
        normalOnceRewardAmount: 0,
        superOnceReferralAmount: 0,
        friendsAmount: 0,
        dividendYield: 0,
        xpCanClaimAmount: 0,
        inviteCode: "",
        listData: []
    },

    data() {
        return {
            // listData: [],
            // inviteCode: "",
            // inviteUrl: "",
            // inviteDispayUrl: "",
            // xpCanClaimAmount: "",
            isClaim: false,
            shareTitle: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!",
            shareTxt: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
            facebook_url: "",
            twitter_url: "",
            email_url: "",
            in_url: "",
            tg_url: "",
        }
    },

    watch: {
        inviteUrl(value) {
            this.facebook_url = 'https://www.facebook.com/sharer.php?s=100&u=' + encodeURIComponent(this.inviteUrl) + "&title=" + this.shareTitle;
            this.twitter_url = 'http://twitter.com/share?url=' + encodeURIComponent(this.inviteUrl) + "&text=" + this.shareTitle;
            this.email_url = 'mailto:?subject=' + this.shareTitle + '&body=' + encodeURIComponent(this.inviteUrl);
            this.in_url = 'https://www.messenger.com/?' + encodeURIComponent(this.inviteUrl) + "&title=" + this.shareTitle;
            this.tg_url = 'https://telegram.me/share/url?url=' + encodeURIComponent(this.inviteUrl) + "&text=" + this.shareTxt + "&title=" + this.shareTitle;
        },

        xpCanClaimAmount(value) {
            this.isClaim = false;
        }



    },

    methods: {
        pcBack() {
            let view = document.getElementById("bee_nInvite");
            view.style.display = "none";
        },


        xcopyToClipboard(copyText) {
            navigator.clipboard.writeText(copyText).then(() => {
                Toast("Copy successful", "success")
            });

        },

        async clickClaim() {
            if (this.xpCanClaimAmount == 0) {
                return;
            }
            this.isClaim = true;
            let rDate = await InviteInfoStore.referralClaim();
            this.$emit("claim", 0);
        },
        share() {
            if (navigator.share) {
                navigator.share({
                    title: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!",
                    text: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
                    url: this.inviteUrl
                }).then(() => {
                    console.log('Successful share');
                }).catch(error => {
                    console.log('Error sharing:', error);
                });
            } else {
                navigator.clipboard.writeText(this.inviteUrl).then(() => {
                    Toast("Copy successful", "success")
                });
            }
        },



    },

    mounted() {
    },


}

</script>

<style scoped>
.bee_pc_invite_base_layout {
    flex-direction: column;
    display: flex;
    align-items: center;
    height: 95%;
}



.empty_share_div {
    width: 16px;
    height: 16px;
    background-image: url("../../assets/icon_share_img.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.empty_share_text {
    color: #FFF;
    text-align: center;
    font-family: "SF Pro Display";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 4px;
}

.empty_share_btn {
    display: flex;
    border-radius: 8px;
    background: #FFAB13;
    height: 45px;
    margin-left: 16px;
    margin-right: 16px;
    width: -webkit-fill-available;
    width: -moz-available;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.pc_header {
    background: #FFF;
    width: -webkit-fill-available;
    width: -moz-available;
    height: 55px;
    align-items: center;
    display: flex;
    justify-content: center;
}

.pc_back_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* margin-top: 20px; */
    /* margin-bottom: 16px; */
    padding-top: 20px;
    padding-bottom: 20px;
    background: #EDF2F7;
}

.pc_content_layout {
    width: 1200px;
    display: flex;
    flex-direction: column;
    height: 96%;
    /* height: 800px; */
}

.img_ipx {
    width: 334px;
    height: 277px;
    margin-right: 16px;
    background-image: url("../../assets/icon_top_pc_i.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.invite_info_layout {
    display: flex;
    flex-direction: row;
    padding-left: 200px;
    padding-right: 200px;
    background-color: #FFEFDA;
    align-items: center;
    justify-content: space-between;
    background-image: url("../../assets/icon_pc_bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;

}

.invite_info {
    color: #000;
    font-family: "SF Pro Text";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    width: 384px
}

.pc_invite_content_layout {
    display: flex;
    flex-direction: column;
    padding-left: 200px;
    padding-right: 200px;
    background-color: #ffffff;
    /* overflow: hidden; */
    height: -webkit-fill-available;
    height: -moz-available;
    height: 500px;
}

.my_invite_xp_layout {
    border-radius: 8px;
    background: #F8F8F8;
    display: flex;
    justify-content: space-between;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 4px;
    padding: 20px;
    align-items: center;
}

.submit_get {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    border-radius: 8px;
    background: linear-gradient(90deg, #FFBF6C 0%, #F68F1A 100%);
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}


.submit_load {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    border-radius: 8px;
    background: #FFE7B3;
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    width: 60px;
    display: flex;
}



.my_txt {
    color: #666;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.xp_txt {
    color: #000;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.index_base_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 12px;
}

.invite_layout {
    border-radius: 8px;
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}

.invite_left_txt {
    color: #666;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.xp_num_txt {
    color: #000;
    font-family: "SF Pro Text";
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.index_layout {
    width: 2px;
    height: 14px;
    background: #FFC04D;
    margin-right: 4px;
}

.index_title {
    color: #333;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.invite_right_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: right;
    flex: 1;
}

.invite_right_txt_pc {
    color: #000;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: right;
    white-space: nowrap;
    /* overflow: hidden; */
}

.icon_copy {
    width: 20px;
    height: 20px;
    background-image: url("../../assets/icon_copy.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-left: 12px;
    cursor: pointer;
}

.ic_back {
    width: 22px;
    height: 22px;
    background-image: url("../../assets/ic_pc_back.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    cursor: pointer;
    margin-right: 8px;
}

.ic_back_right {
    width: 14px;
    height: 14px;
    background-image: url("../../assets/ic_r.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-right: 4px;
    margin-left: 4px;
}

.line {
    display: flex;
    height: 1px;
    stroke-width: 1px;
    stroke: rgba(240, 238, 238, 0.93);
    background-color: rgba(240, 238, 238, 0.93);
    margin-left: 12px;
    margin-right: 12px;
    width: -webkit-fill-available;
    width: -moz-available;
}

.invite_item_layout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

}

.logo_header {
    width: 1200px;
}

.logo_ic {
    width: 110px;
    height: 24px;
    background-image: url("../../assets/bee_icon_txt.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.back_home_txt {
    color: #999;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.back_invite_txt {
    color: #333;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.x_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_x.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.tg_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_tg.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.fb_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_fb.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.more_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_more.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.share_layout {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
}

.in_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_in.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.email_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_email.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.xp_num {
    color: #E44430;
    font-family: "SF Pro Text";
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
}

.submit_get_un {
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    border-radius: 8px;
    background: #f2f1ef;
    color: #d4d1c9;
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.content_pc_layout {
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    height: -webkit-fill-available;
    height: -moz-available;
    height: 90%;
    border-radius: 12px;
    overflow: auto;
    background-color: #fff;
}

.pc_invite_info_layout {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    margin-right: 16px;
    padding: 12px;
    margin-top: 12px;
}

.red_xp_num {
    color: #F53019;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 900;
    line-height: 20px;
}

.pc_invite_title_txt {
    color: #5D2E21;
    font-size: 58px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.58px;
}

.index_title {
    width: 80px;
    height: 8px;
    flex-shrink: 0;
}
</style>